import type { CSSProperties } from 'react';

interface SkeletonBlockProps {
  className?: string;
  style?: CSSProperties;
}

export const SkeletonBlock = ({
  className = '',
  style,
}: SkeletonBlockProps) => {
  return (
    <div
      aria-hidden="true"
      className={`animate-pulse bg-[#2a2a2a] ${className}`}
      style={style}
    />
  );
};
